import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class PostaladdressComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentPostalAddress | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = settings?.defaultValue;
		this.disabled = settings?.disabled ?? false;
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? false;
		this.protected = settings?.protected ?? true;
		this.size = settings?.size ?? 'md';
		this.spellcheck = settings?.spellcheck ?? true;
		this.theme = settings?.theme ?? 'default';
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'administrative_area_level_1',
			'administrative_area_level_2',
			'cedex',
			'country',
			'locality',
			'location',
			'name',
			'political',
			'postal_box',
			'postal_code',
			'route',
			'route2',
		]);
	}
}
